'use client';
import { MutableRefObject, useEffect, useRef } from 'react';

export const useImpressionObserver = (
  targetRef: MutableRefObject<Element | null>,
  callback: () => void,
  options?: IntersectionObserverInit,
) => {
  const observerRef = useRef<IntersectionObserver | null>(null);
  const callbackFiredRef = useRef(false);

  useEffect(() => {
    if (!targetRef.current || callbackFiredRef.current) {
      return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          callback();
          callbackFiredRef.current = true;
          obs.disconnect();
        }
      });
    }, options);

    observer.observe(targetRef.current);
    observerRef.current = observer;

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, [targetRef, callback, options]);

  return observerRef.current;
};
